module.exports = __webpack_public_path__ + "img/royalpanda.d4c0671d.svg";